import React from "react";

import { useLocation } from "react-router-dom";

import { isCLevelPath } from "../../helpers/isCLevelPath";
import { SmallTitle } from "../../styles/sharedStyles"
import { ButtonAnchor } from "../ButtonAnchor/ButtonAnchor";

import {
  MainTitle,
  Section,
  Text,
} from "./styles"

type TInfoSection = {
  backgroundImage?: string;
}

export const ConsultationBanner: React.FC<TInfoSection> = ({
  backgroundImage,
}) => {

  const location = useLocation();
  const isITTrainingPage = location.pathname === "/services/it-training";
  const isCLevelPage = isCLevelPath(location.pathname);

  return (
    <Section
      bgImage={backgroundImage}
      isCLevelPage={isCLevelPage}
    >
      <SmallTitle isWhite>
        бесплатная консультация
      </SmallTitle>
      <MainTitle>
        {isITTrainingPage ? "Оставить заявку" : "Остались вопросы ?"}
      </MainTitle>
      <Text>Консультация-знакомство это возможность получить ответы
       на все волнующие вопросы.
      </Text>
      <ButtonAnchor
        href="https://t.me/ProhorovaConsult?text=Здравствуйте! Хочу подробнее узнать об услугах"
        title={isITTrainingPage ? "Получить консультацию" : "Оставить заявку"}
      />
    </Section>
  );
};
